import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Grid2, IconButton } from "@mui/material";
import type { ICellRendererParams } from "ag-grid-community";
import React from "react";
import type { EmailTopic } from "../../models/EmailTopic";

type EmailTopicButtonsCellRendererParams = ICellRendererParams<EmailTopic> & {
	editEmailTopic: (topic: EmailTopic) => void;
};

export const ButtonsCellRenderer = (
	params: EmailTopicButtonsCellRendererParams,
) => {
	const { editEmailTopic, data } = params;

	if (!data) {
		return null;
	}

	return (
		<Grid2
			container
			sx={{
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				opacity: 0,
				transition: "opacity 0.1s ease-in-out",
				".ag-row-hover &": {
					opacity: 1,
				},
				".ag-row-focus &": {
					opacity: 1,
				},
				".ag-row-selected &": {
					opacity: 1,
				},
			}}
		>
			<Grid2
				size={{ md: 12, xs: 12 }}
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					gap: "1rem",
				}}
			>
				<IconButton
					onClick={() => {
						editEmailTopic(data);
					}}
					title="Edit"
					size="small"
				>
					<EditIcon sx={{ height: "auto" }} color="primary" />
				</IconButton>
			</Grid2>
		</Grid2>
	);
};
